<template>
  <v-card>

    <v-row>
      <v-col class="ma-1">
        <v-tabs align="start" background-color="blue lighten-5" v-model="tab">
          <v-tab> Paramètres généraux</v-tab>
          <v-tab> Filtre </v-tab>
          <v-tab> Champs récupérés </v-tab>
          <v-tab> Visuels colonnes </v-tab>
          <v-tab> Modules de recherche </v-tab>
          <v-tab> Actions </v-tab>
          <v-tab> Enrichissements métier </v-tab>
          <v-tabs-items v-model="tab" class="pl-4">
            <v-tab-item>
              <!-- PARAM GENERAUX -->
              <span class="text-h6">Bouton d'ajout</span>
              <SwitchC :item="{
                name: 'Affichage du bouton', value: 'display', liste: [{ text: 'OUI', value: true }, { text: 'NON', value: false }],
                defaultprops: { show: true, column: false}
              }" :change="ChangeAddButton"
                :valField="displays.params.ajout.display" />

              <div v-if="displays.params.ajout.display">
                <v-row>

                  <v-col>
                    <TextField :item="{ name: 'Nom du bouton', value: 'text', defaultprops: { show: true } }"
                      :valField="displays.params.ajout.text" :keyup="ChangeAddButton" />
                    <TextField :item="{ name: 'icône', value: 'icon', defaultprops: { show: true } }"
                      :valField="displays.params.ajout.icon" :keyup="ChangeAddButton" />
                    <Select :item="{
                      name: 'type d\'affichage', value: 'type', liste: [{ text: 'en modal', value: 'modal' }, { text: 'en centre', value: 'center' }],
                      defaultprops: { show: true, column: false }
                    }" :change="ChangeAddButton"
                      :valField="displays.params.ajout.type" />
                  </v-col>

                  <v-col class="grey lighten-4" v-if="displays.params.ajout.type == 'modal'">
                    <span class="text-h6">Paramètre modal</span>
                    <paramDialog v-if="displays.params.ajout" :page="page" :params="displays.params.ajout.paramdialog"
                      @returnParamDialog="ChangeParamDialog" />
                  </v-col>
                  <v-col>
                    <ArrayTable 
                    :item="{otherparams:{arrayTable:[{type:'',key:'key',name:'Variable',ArrayValue:FieldsOfModuleTable},{type:'select',key:'type',name:'type de donnée',ArrayValue:[{text:'nombre',value:'number'},{text:'texte',value:'text'},{text:'booleen',value:'bool'}]},{type:'',key:'value',name:'Valeur',description:'(Vous pouvez insérer des variables d\'environnement)'}]},
                    defaultprops:{show:true,tableDraggable:false,tableDel:true,hideFooter:true,hidesearch:true,addTitle:'Ajouter une variable'}}"
                    :valField="displays.params.ajout.variables"
                    :change="(item,model) => { displays.params.ajout.variables = model; }"
                    />
                  </v-col>

                </v-row>
              </div>
              <!-- FIN AJOUT -->
              <!--
              <span class="text-h6">tri</span>
              <Autocomplete

                :item="itemSortBy"
                :valField="displays.params.paramtab.sortBy"
                :change="ChangeParam"
              />
                -->

              <SwitchC :item="{
                name: 'Afficher la checkbox par ligne', value: 'showselect',
                defaultprops: { show: true, column: false }
              }" :change="ChangeParam"
                :valField="displays.params.paramtab.showselect" />

              <SwitchC :item="{
                name: 'Checkbox en entete', value: 'singleselect',
                defaultprops: { show: true, column: false }
              }" :change="ChangeParam"
                :valField="displays.params.paramtab.singleselect" />

              <SwitchC :item="{
                name: 'Masquer la pagination', value: 'hidepagination',
                defaultprops: { show: true, column: false }
              }" :change="ChangeParam"
                :valField="displays.params.paramtab.hidepagination" />

              <SwitchC :item="{
                name: 'Masquer le nombre de lignes', value: 'hidenombrelignes',
                defaultprops: { show: true, column: false }
              }" :change="ChangeParam"
                :valField="displays.params.paramtab.hidenombrelignes" />

              <SwitchC :item="{
                name: 'Masquer les entêtes', value: 'hideheaders',
                defaultprops: { show: true, column: false }
              }" :change="ChangeParam"
                :valField="displays.params.paramtab.hideheaders" />

                <SwitchC :item="{
                name: 'Afficher le tableau uniquement si un filtre est appliqué', value: 'set',
                defaultprops: { show: true, column: false }
              }" 
              :change="(item,value) => { displays.params.displayiffilter.set = value }"
              :valField="displays.params.displayiffilter.set" />

              <TextField :item="{ name: 'Texte à afficher si attente d\'un filtre', value: 'text', defaultprops: { show: true } }"
              v-if="displays.params.displayiffilter.set"
              :valField="displays.params.displayiffilter.text" 
              :keyup="(item,value) => {displays.params.displayiffilter.text = value }" 
              />

              <Autocomplete :item="{
                name: 'Ligne par page',
                value: 'itemsPerPage',
                defaultprops: { show: !displays.params.paramtab.hidepagination },
                liste: [
                  { text: '5', value: 5 },
                  { text: '10', value: 10 },
                  { text: '50', value: 50 },
                  { text: '100', value: 100 },
                ],
              }" :valField="displays.params.paramtab.itemsPerPage" :change="ChangeParam" />
            </v-tab-item>

            <v-tab-item>
              <!-- FILTRES -->
              <Filtre :filtre="displays.filter" :table="module.table"
                @recepVal="(array) => { changeEC(array, 'filter') }" />
            </v-tab-item>

            <v-tab-item>
              <!-- CHAMPS AFFICHES-->
              <v-tabs align="start" background-color="blue lighten-5" v-model="tab2">
                <v-tab> Pour la table</v-tab>
                <v-tab> Pour le fichier excel </v-tab>
              <v-tabs-items v-model="tab2" class="pl-4">
                <v-tab-item>
                  <p>Vous pouvez attribuer une couleur de fond pour une ligne avec la valeur as : 'cellBackColor'</p>
                  <p>Vous pouvez attribuer une couleur de texte pour une colonne avec valeur as : 'rowColor'</p>
                  <p>Vous pouvez attribuer une couleur de fond pour une colonne avec valeur as : 'rowBackColor'</p>
                  <Fields :modalKey="modalKey" :table="module.table" :champs="displays.params.champs" :filter="displays.filter" :page="page"
                    @recepVal="(array) => { changeEC(array, 'champs') }" />                
                </v-tab-item>
                <v-tab-item>
                  
                  <Fields :modalKey="modalKey" :table="module.table" :champs="displays.params.champsexcel" :filter="displays.filter" :page="page"
                    @recepVal="(array) => { changeEC(array, 'champsexcel') }" />                  
                </v-tab-item>
            </v-tabs-items>
            </v-tabs>


            </v-tab-item>


            <v-tab-item>
              <v-alert type="info" text dense class="mt-3 mb-1">
                Vous pouvez utiliser une valeur de la ligne avec la variable
                <code>[[table||mon_alias]]</code>. Les alias disponibles proviennent des champs récupérés par le module.
              </v-alert>
              <Visuels
                :visuels="displays.params.colonnes"
                :fields="visualFields"
                :page="page"
                :modalKey="modalKey"
                @recepVal="(array) => { changeEC(array, 'colonnes') }"
              />
            </v-tab-item>




            <v-tab-item>
              <!-- Modules de recherche -->
              <div class="text-h6">Si le ou les modules sélectionnés se trouvent sur la même page, ils interagieront avec
                le tableau</div>

              <SimpleTable :Headers="[
                  { text: 'ID', value: 'id' },
                  { text: 'type', value: 'type' },
                  { text: 'Nom', value: 'name' },
                  { text: 'Table', value: 'table' },
                  { text: 'champs', value: 'champs' },
              ]" :datas="dataTableSearch" :selected="displays.params.searchmodule" keyRow="id"
                @getselected="getselected" />

              <div class="text-h6">champs selectionnés pour la recherche globale</div>
              <Autocomplete :item="{
                name: 'Champs ciblés pour recherche globale',
                value: 'globalsearch',
                defaultprops: { show: true, multiple: true },
                liste: listFields,
              }" :valField="displays.params.globalsearch" :change="changeGlobalSearch" />

            </v-tab-item>

            <v-tab-item>

              <listActions :page="page" :module="module" :key="reload" :modalKey="modalKey"
                :table-click-rules="displays.params.onclick" :table-columns="displays.params.colonnes" @listActions="getActions" />

              <v-divider class="my-3" />
              <div class="d-flex align-center mb-2">
                <v-btn small outlined class="mr-2" @click="addNewClick"><v-icon small left>mdi-plus</v-icon>Ajouter</v-btn>
                <div>
                  <div class="text-subtitle-2">Attribution des actions sur colonne ou ligne</div>
                  <div class="text-caption text--secondary">Choisissez une colonne, un élément identifié du visuel ou toute la ligne.</div>
                </div>
              </div>

              <v-alert v-if="ambiguousClickTargets" dense text type="warning" class="mb-2">Clés de cible ambiguës : {{ ambiguousClickTargets }}. Utilisez des clés uniques dans chaque colonne.</v-alert>
              <v-sheet v-for="fclick, i in displays.params.onclick" :key="'f'+i" outlined rounded class="table-click-rule">
                <v-select :value="clickTargetValue(fclick)" :items="clickTargets" label="Cible du clic" dense outlined hide-details class="table-click-rule__target"
                  @change="value => changeClickTarget(i, value)" />
                <v-select v-model="fclick.type" label="Type" dense outlined hide-details class="table-click-rule__type"
                  :items="[{text:'Lancer une action',value:'action'},{text:'Modifier un champ',value:'field'}]" />
                <v-select v-if="ClistActions.length && fclick.type=='action'" v-model="fclick.action" label="Action au clic"
                  :items="ClistActions" dense outlined hide-details class="table-click-rule__selection" />
                <v-select v-if="fclick.type=='action'" v-model="fclick.openmode" label="Ouverture" dense outlined hide-details class="table-click-rule__mode"
                  :items="[{text:'Selon l’action',value:'origin'},{text:'Sous la ligne',value:'underline'}]" />
                <v-autocomplete v-if="fclick.type=='field'" :value="fclick.listFieldsUpdate" :items="defineDefaultlistFields"
                  label="Champs à modifier" multiple dense outlined hide-details class="table-click-rule__selection"
                  @change="value => changeUpdateFieldsOnClick(i, {}, value, 'value')" />
                <v-btn icon small color="error" :aria-label="'Supprimer la règle '+(i+1)" title="Supprimer cette attribution" @click="removeClick(i)">
                  <v-icon small>mdi-delete-outline</v-icon>
                </v-btn>
              </v-sheet>

            </v-tab-item>

            <v-tab-item>
              <ModuleEnrichmentConfiguration :value="displays.params.enrichmentsMetier || []" :module-id="module.id" :fields="queryVisualFields"
                @input="value => $set(displays.params, 'enrichmentsMetier', value)" @fields="value => enrichmentFields = value" />
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-col>
    </v-row>
  </v-card>
</template>



<script>
import { admin } from '../mixins';
import ModuleEnrichmentConfiguration from '../../engine/outils/moduleEnrichments/Configuration.vue'
import { actionTargetOptions, targetValue } from './actionTargets'
export default {
  name: "TableModule",

  mixins : [admin],

  props: ["module", "page","buildingParameters","modalKey"],

  components: {
    ModuleEnrichmentConfiguration,
    Visuels: () => import('../../engine/outils/constructVisuel/Visuel.vue'),
  },

  data: function () {
    return {

      tab: null,
      tab2 : '',
      itemSomme: { multiple: true, name: "Champs pour les sommes", value: "somme", liste: [] },
      itemSortBy: {
        multiple: true, name: "Trier par", value: "sortBy", liste: [],
        defaultprops: {
          show: true,
          chips: true,
          deletablechips: true,
          multiple: true,
          description: 'choisissez le tri de colonne',
          persistenthint: true,
        }
      },
      displays: this.module.displays,
      dataTableSearch: [],
      reload: 0,
      listFields: [],
      FieldsOfModuleTable: [],
      listPages : [],
      listActions : [],
      enrichmentFields: [],

    };
  },

  watch: {
    showMod: {
      // permet de rafraichir quand la modal de la page se ferme
      handler(val) {
        if (val.show === false) {
          this.reload++;
        }

      },
      deep: true,
    },

  },

    computed: {
      clickTargets() { return actionTargetOptions(this.displays.params, this.displays.params.onclick) },
      ambiguousClickTargets() { return this.clickTargets.filter(option => option.disabled).map(option => option.text).join(', ') },
      ClistActions () {

        const dynamic = this.listActions.map(ch => ({
          text: ch.name,
          value: ch.id
        }))
        return dynamic
      },

      defineDefaultlistFields() {
        const dynamic = this.listFields.filter(ch => ch.table === this.module.table && ch.id!==false).map(ch => ({
          text: ch.text,
          value: ch.id
        }))
        return dynamic
      },

      queryVisualFields() {
        return (this.displays.params.champs || [])
          .filter(field => field && field.as)
          .map(field => ({ text: field.as, value: field.as }))
      },
      visualFields() { return [...this.queryVisualFields, ...this.enrichmentFields] }
    },

  methods: {
    clickTargetValue: targetValue,
    changeClickTarget(index, value) {
      const target = this.clickTargets.find(option => option.value === value)
      if (!target || target.disabled) return
      this.$set(this.displays.params.onclick[index], 'field', target.field)
      this.$set(this.displays.params.onclick[index], 'elementKey', target.elementKey)
      this.$emit('recepVal', this.displays)
    },


    addNewClick() {
      let click = JSON.parse(JSON.stringify(this.buildingParameters.table.clickline));
      this.displays.params.onclick.push(click)
    },
    removeClick(key) {
      this.displays.params.onclick = this.displays.params.onclick.filter((el,i)=> i!=key);
      this.$emit('recepVal',this.displays);
    },

    getActions(actions) {
      this.listActions = actions
    },

    getsearchFromAPI() {
      this.API({ type: 'post', url: "/engine/module/list", params: { type: ["search","echarts"] } }).then((resp) => {

        resp.data.forEach((v) => {
          let champs = (v.displays.params.champs) ? v.displays.params.champs.join(", ") : "--";
          this.dataTableSearch.push({
            id: v.id,
            type: v.type,
            name: v.name,
            table: v.table,
            champs: champs,
          });
        });
        // pour intégrer la recherche globale :
        this.dataTableSearch.push({ id: 'global', champs: 'sensible au champ de la recherche globale' });
      });
    },


    //permet de récupérer les champs issues de la requete pur les insérer dans la recherche globale
    getFields() {

      this.API({ type: 'post', url: 'engine/module/getfieldswithjunctions', params: { table: this.module.table, filter: this.displays.filter } }).then((resp) => {
        this.Fields = resp.data.fields
        resp.data.fields.forEach((field) => {
          this.listFields.push({ 'text': field.table + '.' + field.field, value: field.cle, id:field.id, table:field.table })
          if(field.table == this.module.table) this.FieldsOfModuleTable.push({ 'text': field.table + '.' + field.field, value: field.cle, default:'value' })
        })
      })

    },


    changeEC(array, type) {
      this.displays.params[type] = array;
      this.$emit('recepVal', this.displays)
      if (type == 'filter') this.constructListSort();
    },

    changeGlobalSearch(item, value, selectedKey) {
      this.displays.params.globalsearch = [];
      for (var selected in value) {
        if (typeof value[selected] == 'object') { this.displays.params.globalsearch.push(value[selected][selectedKey]) } else { this.displays.params.globalsearch.push(value[selected]); }
      }
      this.$emit('recepVal', this.displays)
    },

    changeUpdateFieldsOnClick(i,item, value, selectedKey) {
      this.displays.params.onclick[i].listFieldsUpdate = [];
      console.log(value)
      for (var selected in value) {
        if (typeof value[selected] == 'object') { this.displays.params.onclick[i].listFieldsUpdate.push(value[selected][selectedKey]) } else { this.displays.params.onclick[i].listFieldsUpdate.push(value[selected]); }
      }
      this.$emit('recepVal', this.displays)
    },

    getselected(val) {
      this.displays.params.searchmodule = val;
      this.$emit('recepVal', this.displays)
    },

    ChangeParam(item, value, selectedKey) {

      if (item.multiple) {
        this.displays.params.paramtab[item.value] = []
        for (var selected in value) {
          if (typeof value[selected] == 'object') { this.displays.params.paramtab[item.value].push(value[selected][selectedKey]) } else { this.displays.params.paramtab[item.value].push(value[selected]); }
        }
      } else {
        var realValue = (typeof value === 'object') ? value[selectedKey] : value;
        this.displays.params.paramtab[item.value] = realValue;
      }

      this.$emit('recepVal', this.displays)
    },

    ChangeAddButton(item, value, selectedKey) {
      var realValue = (typeof value == 'object') ? value[selectedKey] : value;
      this.displays.params.ajout[item.value] = realValue;
      this.$emit('recepVal', this.displays)
    },

    ChangeParamDialog(data) {
      this.displays.params.ajout.paramdialog = data;
      this.$emit('recepVal', this.displays)
    },

    constructListSort() {
      this.itemSortBy.liste = []
      if (this.displays.params.champs.length == 0) return

      this.displays.params.champs.forEach((v) => {
        this.itemSortBy.liste.push({ text: v.as, value: v.as });
      })
    }

  },

  mounted() {
    this.getsearchFromAPI();
    this.constructListSort();
    this.getFields();
    //récupère les pages pour selection sur click de colonne ou de ligne : //

      this.API({ type: 'get', url: 'allpage' }).then((resp) => {
      this.listPages.push({text:'aucune',value:null});
      resp.data.forEach((page) => {
          this.listPages.push({text:page.displays.displayname+" ("+page.url+")",value:page.id});
      })

      })


  },
};
</script>

<style scoped>
.table-click-rule { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; padding: 8px; margin-bottom: 8px; }
.table-click-rule__target { flex: 1 1 130px; min-width: 0; }
.table-click-rule__type { flex: 1.2 1 170px; min-width: 0; }
.table-click-rule__selection { flex: 2 1 220px; min-width: 0; }
.table-click-rule__mode { flex: 1.3 1 180px; min-width: 0; }
@media (max-width: 600px) {
  .table-click-rule__selection { flex-basis: 100%; }
}
</style>

